<template>
  <div class="column is-6 is-paddingless-touch">
    <div class="comment">
      <div
        class="comment-heading columns"
        @click="switchVenueDetails()"
      >
        <div class="column is-12 card-header has-text-centered">
          <strong
            class="card-user-name"
            :class="{active: venueDetails}"
          >Venue Details</strong>
        </div>
      </div>
      <div v-if="venueDetails">
        <div class="card-content">
          <div class="columns is-flex flex-wrap top-player">
            <div class="column is-8 is-8-touch no-bordered">
              <h5 class="title is-5 pb-1">
                {{ game.venueInformation.name }}
              </h5>
              <div class="subtitle is-6 has-text-dark">
                <i
                  class="far fa-map-marker"
                  aria-hidden="true"
                />
                {{ game.venueInformation.street1 }},
                <span v-if="game.venueInformation.street2">{{ game.venueInformation.street2 }},</span>
                <span v-if="game.venueInformation.city">{{ game.venueInformation.city }},</span>
                <span v-if="game.venueInformation.state">{{ game.venueInformation.state }},</span>
                {{ game.venueInformation.zip }}
              </div>
              <div>
                Phone:<br>
                <a>{{ game.venueInformation.phone }}</a>
              </div>
              <div>
                Website:<br>
                <a
                  :href="`//${game.venueInformation.website}`"
                  target="_blank"
                >{{ game.venueInformation.website }}</a>
              </div>
              <a
                class="is-block"
                :href="game.venueInformation.mapquest"
                target="_blank"
              >Map / Directions</a>
              <div class="is-flex">
                <div
                  v-if="game.venueInformation.icons.wifi"
                  class="icon-bordered is-flex tooltip"
                  data-tooltip="WiFi Available"
                >
                  <img src="/images/wifi.png">
                </div>
                <div
                  v-if="game.venueInformation.icons.smoke"
                  class="icon-bordered is-flex tooltip"
                  data-tooltip="No Smoking"
                >
                  <img src="/images/do-not-smoke.png">
                </div>
                <div
                  v-if="game.venueInformation.icons.pool"
                  class="icon-bordered is-flex tooltip"
                  data-tooltip="Pool Tables Available"
                >
                  <img src="/images/pool.png">
                </div>
                <div
                  v-if="game.venueInformation.icons.music"
                  class="icon-bordered is-flex tooltip"
                  data-tooltip="Live Music"
                >
                  <img src="/images/music.png">
                </div>
                <div
                  v-if="game.venueInformation.icons.sports"
                  class="icon-bordered is-flex tooltip"
                  data-tooltip="Sports on TV"
                >
                  <img src="/images/tv.png">
                </div>
              </div>
            </div>
            <div
              v-if="game.venueInformation.barLeader"
              class="column is-4 is-4-touch has-text-centered"
            >
              <h5 class="title is-5">
                TOP PLAYER
              </h5>
              <router-link
                v-if="game.venueInformation.barLeader.name"
                :to="`/players/${game.venueInformation.barLeader.ahlid}`"
                class="has-text-info has-text-weight-bold"
              >
                {{ game.venueInformation.barLeader.name }}
              </router-link>
              <div>{{ game.venueInformation.barLeader.totalpoints }} points</div>
              <img
                v-if="game.venueInformation.barLeader.memberphoto"
                class="avatar"
                :src="game.venueInformation.barLeader.memberphoto"
              >
              <img
                v-else
                class="avatar"
                src="/images/profile.png"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['game'],
    data () {
      return {
        venueDetails: true
      }
    },
    methods: {
      switchVenueDetails () {
        this.venueDetails = !this.venueDetails
      }
    }
  }
</script>
